class CommingSoonBadge extends HTMLElement {
  connectedCallback() {
    const publishDateTime = this.getAttribute('publish-date-time');
    const badgeId = this.getAttribute('badge-id');
    const standardBadgesId = this.getAttribute('standard-badges-id');

    if (!publishDateTime || !badgeId || !standardBadgesId) {
      return;
    }

    const now = new Date();
    const publishDate = new Date(publishDateTime);
    const badge = document.getElementById(badgeId);
    const standardBadges = document.getElementById(standardBadgesId);

    if (badge && publishDate > now) {
      badge.style.display = 'block';
      if (standardBadges) {
        standardBadges.style.display = 'none';
      }
    }
  }
}

if (!customElements.get('comming-soon-badge')) {
  customElements.define('comming-soon-badge', CommingSoonBadge);
}
